import React from "react";
import { useConfig } from "../../contexts/ConfigContext";
import { useLanguage } from "../../contexts/LanguageContext";
import { Model } from "../../types";

interface ModelItemProps {
  model: Model;
  displayName: string;
}

const ModelItem: React.FC<ModelItemProps> = ({ model, displayName }) => {
  const { updateModelVisibility, updateModelOpacity } = useConfig();
  const { t } = useLanguage();

  const handleVisibilityChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ): void => {
    updateModelVisibility(model.id, e.target.checked);
  };

  const handleOpacityChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const sliderValue = parseInt(e.target.value, 10);
    // Конвертируем 0-100 в 0.0-1.0, разрешаем полную прозрачность (0)
    const opacity = sliderValue / 100;
    updateModelOpacity(model.id, opacity);
  };

  // Вычисляем процентное значение для отображения и слайдера
  const opacityPercent = Math.round(model.opacity * 100);

  return (
    <div className="model-item">
      <div className="model-header">
        <span className="model-name">{displayName}</span>
        <input
          type="checkbox"
          className="model-checkbox"
          checked={model.isVisible}
          onChange={handleVisibilityChange}
        />
      </div>
      {model.canChangeTransparency && (
        <div className="opacity-control">
          <div className="opacity-label">
            {t("opacity")}: {opacityPercent}%
          </div>
          <input
            type="range"
            className="opacity-slider"
            min="0" // Разрешаем минимум 0
            max="100"
            step="1" // Добавляем шаг для точности
            value={opacityPercent}
            onChange={handleOpacityChange}
            style={
              { "--fill-percent": `${opacityPercent}%` } as React.CSSProperties
            }
          />
        </div>
      )}
    </div>
  );
};

export default ModelItem;
